/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { compose, withApollo } from 'react-apollo'
// import { Link } from 'react-router-dom'
import {
  message, Form, Input, Icon, Button, Card,
} from 'antd'

import { useHistory, withRouter } from 'react-router-dom'

import logo from './img/logo.png'
import { loginUser } from './auth'
import currentUserQuery from './graphql/queries/currentUser'

const Login = (props) => {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        const { data } = await props.client.query({
          query: currentUserQuery,
          fetchPolicy: 'network-only',
        })
        if (data.currentUser !== null) {
          console.log(data.currentUser)
          history.push('/home')
        }
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    }
    getCurrentUser()
  }, [props.client, setLoading])
  const handleLogin = (e) => {
    e.preventDefault()
    const { validateFields } = props.form
    validateFields((err, values) => {
      // console.log(err)
      if (!err) {
        setLoading(true)
        loginUser(values).then((res) => {
          if (res.error) {
            setLoading(false)
            return message.error(res.error.message, 10)
          }
          props.history.push('/home')
          // console.log('login response', res)
        })
      }
    })
  }
  // TODO: if login notify
  const { getFieldDecorator } = props.form
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Card loading={loading} style={{ width: 300, marginTop: '30px', borderRadius: '20px' }}>
        <Form onSubmit={handleLogin} className="login-form" style={{ width: '200px', margin: 'auto' }}>
          <Form.Item>
            <img src={logo} style={{ margin: 'auto', display: 'block' }} alt="Thai.run" />
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('email', {
              rules: [{ required: true, message: 'Please input your email!' }],
            })(
              <Input prefix={<Icon type="user" style={{ fontSize: 13 }} />} placeholder="email" />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password!' }],
            })(
              <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="Password" />
            )}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button" style={{ width: '100%', marginBottom: '6px' }}>
                Log in
            </Button>
            <Button style={{ width: '100%' }}>
                Register
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

export default compose(
  Form.create(),
  withRouter,
  withApollo
)(Login)




// WEBPACK FOOTER //
// ./src/Login.js